import DashboardPage from '@components/pages/dashboard'
import Appearance from '@routes/settings/routes/user/appearance/Appearance'
import MultiFactorAuth from '@routes/settings/routes/user/multiFactorAuth/MultiFactorAuth'
import UserDetails from '@routes/settings/routes/user/userDetails/UserDetails'
import { PageWrapper } from './settings.user.route.styles'

const UserPage = () => (
    <DashboardPage name="settings-user">
        <PageWrapper>
            <UserDetails />
            <MultiFactorAuth />
            <Appearance />
        </PageWrapper>
    </DashboardPage>
)

export default UserPage
